<template>
  <div class="chart-bar-monitoring" :class="{ 'chart-bar-monitoring_with-legend': showLegend }">
    <div class="chart-bar-monitoring__scroll" :style="scrollStyle">
      <EChartsHorizontalBar
        :key="chartHeight"
        :labels="chartLabels"
        :dataset="chartDataset"
        stack
        :showLegend="showLegend"
        :showSeriesLabel="showSeriesLabel"
        :showValueAxisLabels="false"
        :height="chartHeight"
        :valueFractionDigits="0"
        :minWidth="500"
        :categoryLabelWidth="280"
        :barMaxWidth="22"
        labelColor="#FFFFFF"
        legendIcon="roundRect"
        :emptyMessage="emptyMessage"
        :isLoading="isLoading"
      />
    </div>
  </div>
</template>

<script>
  import EChartsHorizontalBar from '@/components/ChartComponents/apacheEcharts/EChartsHorizontalBar.vue';

  const DEFAULT_MONITORING_SEGMENTS = [
    { label: 'Просрочено', color: 'rgba(240, 79, 79, 0.9)' },
    { label: 'В работе', color: 'rgba(100, 173, 239, 0.9)' },
    { label: 'Выполнено', color: 'rgba(120, 210, 140, 0.9)' },
  ];

  const ROW_HEIGHT = 36;
  const CHART_CHROME_HEIGHT = 56;
  const LEGEND_CHROME_HEIGHT = 48;
  const DEFAULT_MAX_HEIGHT = 500;

  export default {
    name: 'ChartBarMonitoring',
    components: {
      EChartsHorizontalBar,
    },
    props: {
      seriesProp: {
        type: Array,
        default: () => [],
      },
      /**
       * Сегменты стека: { label, color }[].
       * Сколько элементов передали — столько областей на столбце (без авто-«Серия N»).
       */
      segments: {
        type: Array,
        default: null,
      },
      template: {
        type: String,
        default: 'default',
      },
      showSeriesLabel: {
        type: Boolean,
        default: true,
      },
      maxHeight: {
        default: DEFAULT_MAX_HEIGHT,
        validator: (value) => value === null || (typeof value === 'number' && !Number.isNaN(value)),
      },
      isLoading: {
        type: Boolean,
        default: false,
      },
      emptyMessage: {
        type: String,
        default: 'Ничего не найдено',
      },
    },
    computed: {
      showLegend() {
        return this.template === 'default' && this.chartDataset.length > 0;
      },
      resolvedSegments() {
        return this.segments?.length ? this.segments : DEFAULT_MONITORING_SEGMENTS;
      },
      chartLabels() {
        return (this.seriesProp ?? []).map((item) => item?.name ?? '');
      },
      chartDataset() {
        if (!this.resolvedSegments.length || !(this.seriesProp ?? []).length) return [];

        return this.resolvedSegments
          .map((segmentMeta, segmentIndex) => {
            const data = (this.seriesProp ?? []).map((item) => Number(item?.data?.[segmentIndex] ?? 0));

            return {
              label: segmentMeta?.label ?? `Серия ${segmentIndex + 1}`,
              color: segmentMeta?.color,
              data,
            };
          })
          .filter((seriesItem) => seriesItem.data.some((value) => value !== 0));
      },
      chartHeight() {
        const legendChrome = this.showLegend ? LEGEND_CHROME_HEIGHT : 0;
        return Math.max(100, this.chartLabels.length * ROW_HEIGHT + CHART_CHROME_HEIGHT + legendChrome);
      },
      scrollStyle() {
        if (this.maxHeight == null) return undefined;

        return {
          maxHeight: `${this.maxHeight}px`,
          overflow: 'auto',
        };
      },
    },
  };
</script>

<style scoped lang="scss">
  .chart-bar-monitoring {
    position: relative;
    width: 100%;

    &_with-legend {
      padding-bottom: 8px;
    }
  }
</style>
